import { render, staticRenderFns, recyclableRender, components } from "./confirm-invoice-issuance.vue?vue&type=template&id=52cbb0ce&scoped=true&"
var renderjs
import script from "./confirm-invoice-issuance.vue?vue&type=script&lang=js&"
export * from "./confirm-invoice-issuance.vue?vue&type=script&lang=js&"
import style0 from "./confirm-invoice-issuance.vue?vue&type=style&index=0&id=52cbb0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cbb0ce",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/confirm-invoice-issuance/confirm-invoice-issuance.vue"
export default component.exports